// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3z_vF","ranges":"BmiRanges_ranges__O0_Q0"};